
export default {
  props: {
    isNegative: {
      type: Boolean,
      default: false,
    },

    isGray: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      isHover: false,
    }
  },
}
